export default __webpack_public_path__ + "static/media/PLANET.c894b463.png";